import { useEffect, useState } from "react";
import { FileDown } from "lucide-react";
import { api, apiErr } from "../../lib/api";
import { toast } from "sonner";
import { Card, Label, Loading, fmtDate } from "./MeHome";

const API = process.env.REACT_APP_BACKEND_URL;

export default function MeDocs() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/me/documents").then((r) => setD(r.data)).catch((e) => toast.error(apiErr(e))); }, []);
  if (!d) return <Loading />;
  return (
    <div className="space-y-5" data-testid="me-documents">
      <div><Label>Documents</Label><h1 className="text-4xl font-extrabold tracking-tight mt-2 text-slate-900">Tax slips & records</h1></div>
      <Card>
        <Label>T4 slips</Label>
        {d.t4_years.length === 0 && <div className="emp-empty mt-3">Your T4 for the current year will appear here after year-end.</div>}
        <div className="mt-2 divide-y divide-slate-100">
          {d.t4_years.map((y) => (
            <div key={y} className="flex items-center justify-between py-3" data-testid={`me-t4-${y}`}>
              <div className="font-bold text-slate-900">T4 — {y}</div>
              <a href={`${API}/api/me/t4/${y}.pdf`} target="_blank" rel="noreferrer" className="emp-btn-secondary"><FileDown className="h-4 w-4" /> PDF</a>
            </div>
          ))}
        </div>
      </Card>
      <Card data-testid="me-roe">
        <Label>Record of Employment</Label>
        {d.roe ? (
          <div className="flex items-center justify-between mt-2">
            <div><div className="font-bold text-slate-900">ROE · {d.roe.status}</div><div className="text-sm text-slate-500">Last day paid {fmtDate(d.roe.last_day)}</div></div>
            <a href={`${API}/api/me/roe.pdf`} target="_blank" rel="noreferrer" className="emp-btn-secondary"><FileDown className="h-4 w-4" /> PDF</a>
          </div>
        ) : <div className="emp-empty mt-3">No Record of Employment has been issued.</div>}
      </Card>
    </div>
  );
}
